import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { setCockpitAttentionSearch } from '../../../model/financialCockpitSlice'
import { selectCockpitAttentionSearch } from '../../../model/selectors'

/** What the reader is looking for on the grouped level: a partner's name, or a PBM's name or
 *  email. Held in the slice, because the header searches a list the tile below it draws. */
export const useAttentionSearch = () => {
  const dispatch = useAppDispatch()
  const search = useSelector(selectCockpitAttentionSearch)

  const setSearch = useCallback(
    (next: string) => dispatch(setCockpitAttentionSearch(next)),
    [dispatch]
  )

  return { search, setSearch }
}
